import { KitDeletionArea } from "@/components/KitDeletionArea";
import { ProfilePictureSelector } from "@/components/ProfilePictureSelector";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { AppTopRightMenu } from "@/components/app-layout/AppTopRightMenu";
import DisplayEditor from "@/components/display/display-editor/DisplayEditor";
import { GrantDialog } from "@/components/grant/GrantDialog";
import { Column } from "@/components/ui/flex";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export default function PresetSettingsPage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { kit, updateKit } = useKitData(groupUuid, kitUuid);

  if (!kit || !groupUuid) {
    return null;
  }

  return (
    <>
      <AppTopRightMenu.ContentPortal display="append">
        <GrantDialog
          groupUuid={groupUuid}
          objectName={kit.name}
          kitUuid={kit.uuid}
        />
      </AppTopRightMenu.ContentPortal>
      <Page>
        <PageHeader>
          <PageHeader.Title>Preset Settings</PageHeader.Title>
        </PageHeader>
        <PageBody>
          <DisplayEditor
            name={kit.name}
            description={kit.description}
            onNameChange={(name) => updateKit({ name })}
            onDescriptionChange={(description) => updateKit({ description })}
          />

          <Column className="gap-4">
            <h2 className="text-xl font-bold">Cover Image</h2>
            <div className="bg-background rounded-lg p-4">
              <ProfilePictureSelector
                profilePicture={kit.cover_image}
                resizeSize={[140, 70]}
                onProfilePictureChange={(profilePicture) => {
                  updateKit({ cover_image: profilePicture });
                }}
              />
            </div>
          </Column>

          <KitDeletionArea kit={kit} />
        </PageBody>
      </Page>
    </>
  );
}
